module.exports = __webpack_public_path__ + "img/icon-default-category.143060c7.png";